import type React from 'react';

export interface FormSectionProps {
  key?: React.Key;
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormSection({ title, description, children, className }: FormSectionProps): JSX.Element {
  const containerClasses = ['rounded-lg border border-slate-200 bg-white p-4', className].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {title ? <h3 className="text-base font-semibold text-slate-900">{title}</h3> : null}
      {description ? <p className="text-sm text-slate-600 mt-1">{description}</p> : null}
      <div className="mt-4 space-y-4">{children}</div>
    </div>
  );
}
